export default {
    privige: {
      credits: "Credits",
      agent: "Agent",
      knowledgeBaseCapacity: "Knowledge Base",
      databaseDataNum: "Built-in Database",
      remoteDatabase: "Remote Database",
      accountNumber: "Accounts",
      customPlugin: "Custom Plugins",
      workFlow: "Workflows",    
      dataDashboard: "Analytics Dashboard",
      channelAccess: "Integrations",
      clientManage: "Client Management",
      aggregateChatManage: "Chat Management",
      teamSpace: "Team Space",
      basicApi: "API Access",
      service: "Support",
      knowledgeMediaCapacity: "Knowledge Base Capacity",
      databaseDataNumDes: "Total number of rows in all data tables of the built-in database",
      using: "Selected",
      renew: "Renew",
      start: "Get Started",
      askCustom: "Contact Sales",
      discountTwoYear: "2-Month Discount",
      contactCustomerSupport: "Contact Sales",
      purchaseConsultation: "Contact Us",
      month: "Monthly",
      year: "Yearly",
      yearSelect: " /Year ",
      monthSelect: " /Month ",
      professionalAll: "All benefits of the Team plan",
      enterpriseAll: "Enterprise Agent Marketplace",
      customMember: "Custom Member Limit",
      rolePermission: "Member Role & Permission Management",
      accountStable: "Stable Account Access",
      customerSmart: "AI-Powered Customer Management",
      customBrandLogo: "Custom Brand Logo",
      privateDeployment: "Private Deployment",
      ownModel: "Custom Model Integration",
      higherCapacity: "Enhanced Capacity & Concurrency",
      aiAgentTraining: "AI Agent Training & Optimization Service",
      industrySolution: "Industry Solution Consulting",
      websiteIntegration: "Website Integration",
      websiteIntegrationDes: " (Custom Brand Logo)",
      scoreDes: "credits",
      buyNow: "Buy Now",
      alreadyPrivilegeUser: "You already have a premium plan. Please contact customer service to upgrade.",
      dataPreparing: "Data is still being prepared, please wait a moment or refresh the page later",
      generatingOrder: "Generating order...",
    },
  };